<div class="">
  <div class="grid grid-cols-1 gap-2 sm:grid-cols-1 px-1 py-2">
      <form [formGroup]="searching" class="lg:flex sm:grid-cols-1 gap-4 w-full table-cell">
          <div>
              <mat-form-field class="w-full">
                  <mat-label>Buscar...</mat-label>
                  <input matInput #input class="filter w-full" formControlName="search">
                  <button mat-icon-button type="submit" (click)="getOrdenes()"
                      matSuffix><mat-icon>search</mat-icon></button>
                  <mat-icon matIconPrefix *ngIf="searching.value.search"
                      (click)="searching.reset(); getOrdenes()">close</mat-icon>
              </mat-form-field>
          </div>
          <div >
              <mat-form-field  class="w-full">
                  <mat-label>Fecha Desde - Hasta </mat-label>
                  <mat-date-range-input [rangePicker]="picker" [formGroup]="range">
                      <input matStartDate placeholder="Desde" formControlName="start" name="since">
                      <input matEndDate placeholder="Hasta" formControlName="end" name="until"
                          (dateChange)="getOrdenes()">
                  </mat-date-range-input>
                  <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                  <mat-icon matIconPrefix *ngIf="range.value.start"
                      (click)="range.reset(); getOrdenes()">close</mat-icon>
              </mat-form-field>
          </div>
          <div class="flex flex-cols-2 justify-between gap-x-4 mx-4">
              <!-- <div class="flex flex-col mx-4 ">
                  <p> {{searching.value.checked ? 'Confirmados': 'Sin confirmar'}}</p>
                  <mat-icon class="gap-x-4"
                      [ngClass]="!searching.value.checked ?  'text-gray-600  gap-4' : 'text-green-700 ring-green-600/ gap-4'">{{searching.value.checked
                      ? 'event_available': 'pending_actions'}}</mat-icon>
                  <mat-slide-toggle class="flex" formControlName="checked" (change)="getOrdenes()">
                  </mat-slide-toggle>
              </div> -->
              <button mat-icon color="primary" (click)=" searching.reset(); range.reset(); getOrdenes()" class="m-4"
                  matTooltip="Eliminar filtros">
                  <mat-icon>filter_alt_off</mat-icon></button>
          </div>
      </form>
  </div>
</div>
  <div class="example-container mat-elevation-z8">
      <div class="example-table-container">
          <table mat-table [dataSource]="dataSource"  class="items-center">
              <ng-container matColumnDef="order"  class=" header font-medium bg-gray-900">
                  <th mat-header-cell *matHeaderCellDef class="header"> Orden </th>
                  <td mat-cell *matCellDef="let element">
                      <p class="inline-flex items-center gap-x-1 rounded-md  px-2  font-bold cursor-pointer hover:bg-gray-500/20
                  " matTooltip="Copiar orden" (click)="copyToClipboard(element.order)">
                          {{element.order}}
                          <button type="button" class="group relative -mr-1 h-3.0 w-3.5 rounded-sm ">
                              <span class="sr-only">Copy</span>
                              <svg class="h-6 w-5" viewBox="0 0 20 20" fill="currentColor">
                                  <path
                                      d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z" />
                                  <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
                              </svg>
                              <span class="absolute -inset-1"></span>
                          </button>
                      </p>
                  </td>
              </ng-container>
              <ng-container matColumnDef="seller">
                  <th mat-header-cell *matHeaderCellDef class="header"> Vendedor </th>
                  <td mat-cell *matCellDef="let element"> {{element.seller}}</td>
              </ng-container>
              <ng-container matColumnDef="client">
                  <th mat-header-cell *matHeaderCellDef class="header"> Cliente </th>
                  <td mat-cell *matCellDef="let element"> {{element.client_name}}</td>
              </ng-container>
              <ng-container matColumnDef="client_type_name">
                  <th mat-header-cell *matHeaderCellDef class="header">Tipo de Cliente </th>
                  <td mat-cell *matCellDef="let element">
                      <div matTooltip="{{element.client_type_name}} "
                          *ngIf="element.client_type_name.includes('RESIDENCIAL') "
                          class="w-8 h-8 rounded-full p-1 text-white font-bold  text-center shadow-sm bg-gradient-to-r from-orange-500 to-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 px-2 py-1.0 text-lg ">
                          {{element.client_type_name.charAt(0)}}
                      </div>
                      <div matTooltip="{{element.client_type_name}}"
                          *ngIf="element.client_type_name.includes('PYME')  "
                          class="w-8 h-8 rounded-full p-1 text-white font-bold bg-gray-800 text-center shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 px-2 py-1.0 text-lg ">
                          {{element.client_type_name.charAt(0)}}
                      </div>
                      <div matTooltip="{{element.client_type_name}}"
                          *ngIf="element.client_type_name.includes('EMP G-NETWORK')  "
                          class="w-8 h-8 rounded-full p-1 text-black font-bold bg-gray-300 text-center shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 px-2 py-1.0 text-lg ">
                          {{element.client_type_name.charAt(0)}}
                      </div>
                      <div matTooltip="{{element.client_type_name}}"
                          *ngIf="element.client_type_name.includes('CORPORATIVOS')  "
                          class="w-8 h-8 rounded-full p-1 text-white font-bold bg-gray-600 text-center shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 px-2 py-1.0 text-lg ">
                          {{element.client_type_name.charAt(0)}}
                      </div>
                      <div matTooltip="{{element.client_type_name}}"
                          *ngIf="element.client_type_name.includes('INTERCAMBIO') "
                          class="w-8 h-8 rounded-full p-1 text-white font-bold bg-red-500 text-center shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 px-2 py-1.0 text-lg ">
                          {{element.client_type_name.charAt(0)}}
                      </div>
                      <div matTooltip="{{element.client_type_name}}"
                          *ngIf="element.client_type_name.includes('VENTAS') "
                          class="w-8 h-8 rounded-full p-1 text-white font-bold bg-orange-500 text-center shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 px-2 py-1.0 text-lg ">
                          {{element.client_type_name.charAt(0)}}
                      </div>
                  </td>
              </ng-container>
              <ng-container matColumnDef="payment">
                  <th mat-header-cell *matHeaderCellDef class="header"> Pagado </th>
                  <td mat-cell *matCellDef="let element"><mat-icon
                          [ngClass]="!element.payment ?  'text-gray-600' : 'text-green-700 ring-green-600/'"
                          matTooltip="{{element.payment
                  ? 'Pagado': 'Sin Pagar'}}"> {{element.payment
                          ? 'credit_score': 'cancel'}} </mat-icon></td>
              </ng-container>price_check
              <ng-container matColumnDef="finish">
                  <th mat-header-cell *matHeaderCellDef class="header"> Confirmado </th>
                  <td mat-cell *matCellDef="let element">
                      <mat-icon
                          [ngClass]="!element.confirmation ?  'text-gray-600' : 'text-green-700 ring-green-600/'"
                          matTooltip="{{element.confirmation
                      ? 'Confirmado': 'Sin confirmar'}}"> {{element.confirmation
                          ? 'event_available': 'pending_actions'}} </mat-icon>
                  </td>
              </ng-container>
              <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef class="header"> Agendado</th>
                  <td mat-cell *matCellDef="let element">
                      <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Información"
                          [disabled]="element.status == 43 || element.status == 42">
                          <mat-icon
                              [ngClass]="element.status == 43 || element.status == 42 ?  'text-gray-400' : 'text-green-700 ring-green-600/'">calendar_month</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                          <div mat-menu-item
                              class=" bg-gray-100 border-b dark:border-gray-600 items-center justify-center">
                              <p class="font-semibold text-gray-900 ">Agendado</p>
                          </div>
                          <div mat-menu-item class="px-3 py-2">
                              <div class="flex-1">
                                  <span class="flex" *ngIf="element.start !=null else SinFecha"> {{element.start | date :
                                      'dd/MM/yyyy h:mm a'}}</span>
                                      <ng-template #SinFecha><span class="flex"> Sin Agendar</span> </ng-template>
                              </div>
                          </div>
                      </mat-menu>
                  </td>
              </ng-container>

              <ng-container matColumnDef="create_by">
                  <th mat-header-cell *matHeaderCellDef class="header">Creado por </th>
                  <td mat-cell *matCellDef="let element">
                      <div matTooltip="{{element.created_by_name !=null? element.created_by_name : ''}} "
                          class="w-8 h-8 rounded-full p-1 text-white font-bold  text-center shadow-sm bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 px-2 py-1.0 text-lg ">
                          {{element.created_by_name !=null? element.created_by_name.charAt(0): ''}}
                      </div>
                  </td>
              </ng-container>
              <ng-container matColumnDef="created_at">
                  <th mat-header-cell *matHeaderCellDef class="header">Creado </th>
                  <td mat-cell *matCellDef="let element">
                      <span class="flex"> {{element.created_at | date :
                          'dd/MM/yyyy h:mm a'}}</span>
                  </td>
              </ng-container>

              <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef class="header"> Opciones </th>
                  <td mat-cell *matCellDef="let element">
                      <button mat-icon-button color="primary" matTooltip="Información del Cliente" *ngIf="getPermisos('order_information ')"
                          (click)="ModalContract(element)">
                          <mat-icon>badge</mat-icon>
                      </button>
                      <!-- <button mat-icon-button [disabled]="element.send_wss" matTooltip="Enviar confirmación de orden"
                          (click)="sendConfirmation(element.id)">
                          <mat-icon>mark_email_read</mat-icon>
                      </button>
                      <button mat-icon-button [disabled]="element.send_wss" matTooltip="Enviar confirmación de orden"
                      (click)="sendConfirmation(element.id)">
                      <mat-icon>mark_email_read</mat-icon>
                  </button> -->
                  </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true " class="header items-center"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
          </table>
      </div>
      <mat-paginator [pageSizeOptions]="[10]" showFirstLastButtons [length]="length_pagination"
          (page)="pagination($event)" aria-label="Select page of periodic elements"></mat-paginator>
  </div>
